import styled, { createGlobalStyle } from 'styled-components';

// Only fills the viewport while loading/empty, so loaded cards sit the grid's padding above the footer
// instead of the leftover viewport height.
export const PageWrap = styled.div`
  background: linear-gradient(160deg, rgba(8,8,8,.98) 0%, rgba(12,18,32,.97) 50%, rgba(8,8,8,.98) 100%);
  background-color: #080b12;
  min-height: ${({ $fillViewport }) => ($fillViewport ? '100vh' : '0')};
  margin-top: -72px;
  padding-top: 72px;
  @media (max-width: 768px) { margin-top: -60px; padding-top: 60px; }
`;

// Matches the footer's background so a short page doesn't show the white body below the footer.
export const FooterColorBody = createGlobalStyle`
  body { background: #111111; }
`;

export const NoDataWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 1rem;
  color: #64748b;
  text-align: center;
  min-height: 40vh;
`;

export const NoDataIcon = styled.i`
  font-size: 3rem;
  color: #334155;
  margin-bottom: 1rem;
`;

export const NoDataTitle = styled.h4`
  font-family: 'Poppins', sans-serif;
  font-weight: 700;
  color: #e2e8f0;
  margin-bottom: 0.5rem;
`;

export const NoDataMessage = styled.p`
  font-size: 0.9rem;
  color: #64748b;
  max-width: 420px;
  line-height: 1.6;
`;

export const ErrorWrap = styled.div`
  margin: 1rem 5%;
  padding: 0.85rem 1rem;
  border-radius: 10px;
  border: 1px solid rgba(239, 68, 68, 0.42);
  background: rgba(127, 29, 29, 0.08);
  color: #b91c1c;
  font-weight: 600;
  font-size: 0.9rem;
`;

export const NoticeWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0.5rem 5%;
  padding: 0.7rem 1rem;
  border-radius: 10px;
  border: 1px solid #f7e3bb;
  background: #fbf0da;
  color: #73510d;
  font-weight: 600;
  font-size: 0.88rem;
`;

export const PropsBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding: 0.6rem 1.1rem;
  margin: 0 0 0.4rem;
  background: rgba(14, 116, 144, 0.12);
  border-bottom: 1px solid rgba(34, 211, 238, 0.22);

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
    gap: 0.45rem;
  }
`;

export const PropsBarLabel = styled.span`
  font-size: 0.82rem;
  font-weight: 700;
  color: #a5f3fc;
  display: flex;
  align-items: center;
  gap: 0.4rem;

  i { font-size: 0.78rem; }
`;

export const PropsBarBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.38rem 0.9rem;
  border-radius: 999px;
  border: 1px solid rgba(34, 211, 238, 0.55);
  background: rgba(34, 211, 238, 0.1);
  color: #22d3ee;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  cursor: pointer;
  transition: background 0.18s, border-color 0.18s;

  &:hover {
    background: rgba(34, 211, 238, 0.2);
    border-color: rgba(34, 211, 238, 0.8);
  }

  i { font-size: 0.72rem; }
`;
